import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/admin_navbar";
import AdminSideMenu from "../../components/admin_side_menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Profile = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [createdAt, setCreatedAt] = useState("");

  const getUser = async () => {
    var apiBaseURL = process.env.REACT_APP_API_BASE_URL;
    var accessToken = localStorage.getItem("strutspos_access_token");
    var userID = localStorage.getItem("strutspos_user_id");

    try {
      const res = await axios({
        url: apiBaseURL + "/users/" + userID,
        headers: {
          "x-strutspos-token": accessToken,
          "x-strutspos-application": "user",
        },
        method: "GET",
      });

      let userData = JSON.parse(JSON.stringify(res.data));
      setUser(userData);
      setCreatedAt(userData.created_at.substring(0, 10));
    } catch (err) {
      console.error("getUser err = " + err.message);
    }
  };

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    getUser();

    window.scrollTo(0, 0);
  }, [navigate]);

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Profile Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">Profile</h1>
              <p className="dashboard-subtitle">
                View and manage your account information
              </p>
            </div>
          </div>

          {/* Profile Card */}
          <div className="profile-card-modern">
            <div className="profile-header">
              <div className="profile-avatar">
                <span>
                  {user.first_name
                    ? user.first_name.charAt(0).toUpperCase()
                    : "U"}
                </span>
              </div>
              <div className="profile-info">
                <h2>{user.first_name}'s Profile</h2>
                <p>Account created on {createdAt}</p>
              </div>
            </div>

            <div className="profile-details">
              <div className="detail-row">
                <span className="detail-label">First Name:</span>
                <span className="detail-value">{user.first_name}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Last Name:</span>
                <span className="detail-value">{user.last_name}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Email:</span>
                <span className="detail-value">{user.email}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Created At:</span>
                <span className="detail-value">{createdAt}</span>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Profile;
